import { defineComponent, inject, computed, resolveComponent, openBlock, createBlock, unref, normalizeClass, withCtx, createElementVNode, toDisplayString } from "vue";
import { resolveLinkKey } from "@distancify/drapejs-storyblok";
var Button_vue_vue_type_style_index_0_lang = "";
const __default__ = defineComponent({
  name: "Button"
});
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    block: null
  },
  setup(__props) {
    const props = __props;
    const resolveLink = inject(resolveLinkKey, () => ({}));
    const link = resolveLink(() => props.block.link);
    const target = computed(() => {
      return props.block.target || (link.isExternal ? "_blank" : "_self");
    });
    return (_ctx, _cache) => {
      const _component_router_link = resolveComponent("router-link");
      return openBlock(), createBlock(_component_router_link, {
        to: unref(link).url,
        target: unref(target),
        class: normalizeClass(`button ${__props.block.style ? `button--${__props.block.style}` : ""}`)
      }, {
        default: withCtx(() => [
          createElementVNode("span", {
            class: normalizeClass(`button__inner ${__props.block.style ? `button__inner--${__props.block.style}` : ""}`)
          }, toDisplayString(__props.block.label || unref(link).name), 3)
        ]),
        _: 1
      }, 8, ["to", "target", "class"]);
    };
  }
});
export { _sfc_main as default };
